<template>
   <div v-show="validoffer" class="layout-segment">
      <div class="layout-segment__header">
         <h3 class="layout-segment__title">Zamówienie wstępne</h3>
      </div>

      <a-row :gutter="16">
         <a-col :sm="24" :md="17">
            <form :action="reservationuri" method="post" name="zapytanie" accept-charset="UTF-8" class="order-form order--form" id="offer-form">
               <fieldset>
                  <input type="hidden" name="typ_zapytania" value="ZapytanieRezerwacja"/>
                  <input type="hidden" name="oferta" value=""/>
                  <input type="hidden" name="kodId" value=""/>
                  <input type="hidden" name="tourOp" value=""/>
                  <input type="hidden" name="turnus" value="1"/>
                  <input type="hidden" name="htlCode" value=""/>
                  <input type="hidden" name="htlCat" value=""/>
                  <input type="hidden" name="ileTW" value="0"/>
                  <input name="xcode" type="hidden" value=""/>
                  <input type="hidden" name="hotel" value=""/>
                  <input type="hidden" name="data_od" value=""/>
                  <input type="hidden" name="data_do" value=""/>
                  <input type="hidden" name="dojazd" value=""/>
                  <input type="hidden" name="narty" value=""/>
                  <input type="hidden" name="miasto_wyjazdu" value=""/>
                  <input type="hidden" name="cena" value=""/>
                  <input type="hidden" name="cenawyc"  id="cenawyc" value=""/>
                  <input type="hidden" name="cenacalk" id="cenacalk" value=""/>
                  <input type="hidden" name="season" value=""/>
                  <input type="hidden" name="email2" value=""/>
                  <input type="hidden" name="fax" value=""/>
                  <input type="hidden" name="tel_kom" value=""/>
                  <input type="hidden" name="linf" value=""/>
                  <input type="hidden" name="lchd" value=""/>
                  <input type="hidden" name="ladt" value=""/>
                  <input type="hidden" name="lchage" value=""/>
                  <input type="hidden" name="linkbase" value="http://www.{$properties/serwis}/merlinobiektmds-param.xml"></input>
                  <input type="hidden" name="link" value=""></input>
                  <input type="hidden" name="panstwoid" value="{$properties/panstwo_id}"></input>
                  <input type="hidden" name="plec" value=""/>
                  <input type="hidden" name="adres" value=""/>
                  <input type="hidden" name="kod" value=""/>
                  <input type="hidden" name="miasto" value=""/>
                  <input type="hidden" name="kraj" value=""/>
                  <input type="hidden" name="opobyt" value=""/>
                  <input type="hidden" name="okierunek" value=""/>
                  <input type="hidden" name="owyz" value=""/>
                  <input type="hidden" name="ozakw" value=""/>
                  <input type="hidden" name="otourop" value=""/>
                  <input type="hidden" name="ubez" value=""/>
                  <input type="hidden" name="ubezp" value=""/>
                  <input type="hidden" name="ubezc" value=""/>
                  <input type="hidden" name="domena" :value="getDomena()"/>

                  <div class="order-form__header">
                     <p>Wysyłając formularz wyrażają Państwo zgodę na kontakt telefoniczny lub mailowy od Doradcy <strong>TravelOne.pl</strong>.</p>

                     <div class="order-form__unavailable-info form-box-desc2" style="display: none;" id="form-box-desc2">
                        <p class="font-r font-18">Oferta niedostępna!</p>
                        <p class="mb-none">
                           Zmień daty wyjazdu lub inne parametry.<br>Jeśli potrzebujesz pomocy, skontaktuj się z naszym Centrum Rezerwacji - nr tel.: <a title="71 771 76 21" href="tel:717717621" class="font-20">71 771 76 21</a><br><span>(pn - pt: 9.00 - 17.00, so - nd: 9.00 - 17.00).</span>
                        </p>
                     </div>
                  </div>

                  <div class="order-form__body">
                     <div class="order-form__input-fields">
                        <a-row :gutter="16">
                           <a-col :sm="12">
                              <div class="form-group">
                                 <label class="form-label" for="imie">Imię *</label>
                                 <input type="text" class="form-control form-control_y" id="imie" name="imie"/>
                              </div>
                           </a-col>
                           <a-col :sm="12">
                              <div class="form-group">
                                 <label class="form-label" for="nazwisko">Nazwisko *</label>
                                 <input type="text" class="form-control form-control_y" id="nazwisko" name="nazwisko"/>
                              </div>
                           </a-col>
                        </a-row>

                        <a-row :gutter="16">
                           <a-col :sm="12">
                              <div class="form-group">
                                 <label class="form-label" for="email1">E-mail *</label>
                                 <input type="email" class="form-control form-control_y" id="email1" name="email1"/>
                              </div>
                           </a-col>
                           <a-col :sm="12">
                              <div class="form-group">
                                 <label class="form-label" for="tel_stac">Telefon *</label>
                                 <input type="tel" class="form-control form-control_y" id="tel_stac" name="tel_stac"/>
                              </div>
                           </a-col>
                        </a-row>
                     </div>

                     <div class="order-form__insurance-box term-box insurance" id="ubezpieczenie_box" style="display: none;">
                        <div class="order-form__insurance-option">
                           <label class="checkbox">
                              <input class="custom-checkbox" type="checkbox" value="0" id="ensurance"/>
                              <span class="checkbox-inner"></span>
                              <span class="label-txt">Dodatkowe ubezpieczenie podróżne i od rezygnacji:
                                 <span class="strong">+
                                    <span class="insurance-price" style="display:none;">0</span>
                                    <span class="insurance-currency" style="display:none;">zł</span>
                                    <span class="price-add insurance-value">nieznana</span>
                                 </span>
                              </span>
                           </label>
                        </div>

                        <div class="order-form__insurance-attachments">
                           <a href="/warunki/owu_travel_planet_10012017.pdf" title="ogólne warunki" target="_blank" rel="nofollow">ogólne warunki</a> i <a href="/warunki/tabelki_travel_planet_diamentowy.pdf" target="_blank" rel="nofollow" title="zakres ubezpieczenia">zakres ubezpieczenia</a>
                        </div>
                     </div>

                     <div class="order-form__summary">
                        <div class="order-form__insurance-price">
                           <span class="price-label total-inurance2" style="display: none;">Cena ubezpieczenia:</span>
                           <span class="price-value total-inurance2" style="display: none;" id="total-insurance-price">nieznana</span>
                        </div>
                        <div class="order-form__total-price">
                           <span class="price-label">Cena całkowita:</span>
                           <span class="price-value total-price2" id="total-price2"> {{ pricetotal }} </span>
                        </div>
                     </div>

                     <div>
                      <T1CenaInfo/>
                     </div>

                     <div class="order-form__reservation-info">
                        <!--<xsl:variable name="tfgincluded">
                           <xsl:choose>
                              <xsl:when test="/Page/CenyTFG/Tourop[@kod=$tourOp]/@tfg='0'"><xsl:text>zostanie</xsl:text></xsl:when>
                              <xsl:otherwise><xsl:text>została</xsl:text></xsl:otherwise>
                           </xsl:choose>
                        </xsl:variable>-->
                        <p>Zgodnie z ustawą z dnia 29 sierpnia 1997 r. o usługach turystycznych do rezerwacji imprezy turystycznej <strong>doliczona {{ tfgincludedtext }} składka</strong>, którą Organizator turystyki w całości odprowadza na Turystyczny Fundusz Gwarancyjny. Wysokość składki zależna jest od rodzaju transportu oraz miejsca docelowego imprezy i wynosi maksymalnie 15zł/os.</p>
                        <input type="hidden" class="input-control" id="tfg" name="tfg" value="true"/>
                        <input type="hidden" class="input-control" id="code"/>
                     </div>

                     <div class="order-form__standard-approval">
                        <label class="checkbox">
                           <input type="checkbox" value="0" id="rodo" name="rodo"/>
                           <span class="checkbox-inner"></span>
                           <span class="label-txt">Zgadzam się na kontakt ze strony Travelplanet.pl S.A. w sprawie rozpoczętego procesu rezerwacji na podany przeze mnie adres email lub telefon.*</span><br/><br/>
                           <span>*(wymagane)</span>
                        </label>
                     </div>

                     <a-row type="flex" justify="end">
                        <a-col :xs="24" :sm="12" :lg="9">
                           <input class="btn btn-lg btn-green btn-block order--form--submit" type="submit" value="Zamówienie wstępne" />
                        </a-col>
                     </a-row>
                  </div>
               </fieldset>
            </form>
         </a-col>
      </a-row>
   </div>
</template>

<script>
   import * as CONFIG from './config.js';
   import * as valids from './gen_validatorv3_h.js';
   import T1CenaInfo from "./T1CenaInfo";

   export default {
      data: () => ({
         tfgincluded : false,
         tfgincludedtext : 'została',
         pricetotal: 'nieznana',
         reservationuri: CONFIG.RESERVATION_URL,
	 validoffer: true
      }),
      components: {
        T1CenaInfo
      },
      methods: {
         ble() {
            return 0;
         },
         getDomena() {
	    return CONFIG.serwis;
	 }
      },
      mounted() {
         var that = this;
	 this.$root.$on('update:validoffer', (val1) => {
	      that.validoffer = val1;
	 });
         this.$root.$on('update:pricetotal', (val1) => {
            console.log("NEW totalprice found.");
            this.pricetotal = val1;
            insuranceGet();
            setCheckBoxPrice();
            if (!needGetInsurance) {
               fillParams();
               recalculateFinalPrice(val1);
            }
         });
         validateSubmit();
      }
   }

   function setCheckBoxPrice() {
      jQuery(".custom-checkbox").click(function(e) {
         //e.preventDefault();
         fillParams();
         recalculateFinalPrice('');
      });
   }

   function scrollToForm() {
      var targetOffset = jQuery(".order-form").offset().top;
      jQuery("html, body").animate({scrollTop: targetOffset}, 400);
   }

   function fillParams() {
      jQuery("input[name='oferta']").val(jQuery(".hidden_oferta").attr("value"));
      jQuery("input[name='kodId']").val(jQuery(".hidden_kodId").attr("value"));
      jQuery("input[name='tourOp']").val(jQuery(".hidden_tourOp").attr("value"));
      jQuery("input[name='htlCode']").val(jQuery(".hidden_htlCode").attr("value"));
      jQuery("input[name='xcode']").val(jQuery(".hidden_xcode").attr("value"));
      jQuery("input[name='data_od']").val(jQuery(".hidden_data_od").attr("value"));
      jQuery("input[name='data_do']").val(jQuery(".hidden_data_do").attr("value"));
      jQuery("input[name='dojazd']").val(jQuery(".hidden_dojazd").attr("value"));
      jQuery("input[name='hotel']").val(jQuery(".hidden_hotel").attr("value"));
      jQuery("input[name='miasto_wyjazdu']").val(jQuery(".hidden_miasto_wyjazdu").attr("value"));
      jQuery("input[name='cena']").val(jQuery(".hidden_cena").attr("value"));
      jQuery("input[name='cenawyc']").val(jQuery(".hidden_cenawyc").attr("value"));
      jQuery("input[name='cenacalk']").val(jQuery(".hidden_cenacalk").attr("value"));
      jQuery("input[name='linf']").val(jQuery(".hidden_linf").attr("value"));
      jQuery("input[name='lchd']").val(jQuery(".hidden_lchd").attr("value"));
      jQuery("input[name='ladt']").val(jQuery(".hidden_ladt").attr("value"));
      jQuery("input[name='lchage']").val(jQuery(".hidden_lchage").attr("value"));
      jQuery("input[name='linkbase']").val(jQuery(".hidden_linkbase").attr("value"));
      jQuery("input[name='link']").val(jQuery(".hidden_link").attr("value"));
      jQuery("input[name='panstwoid']").val(jQuery(".hidden_panstwoid").attr("value"));
      jQuery("input[name='opobyt']").val(jQuery(".hidden_opobyt").attr("value"));
      jQuery("input[name='okierunek']").val(jQuery(".hidden_okierunek").attr("value"));
      jQuery("input[name='ozakw']").val(jQuery(".hidden_ozakw").attr("value"));
      jQuery("input[name='otourop']").val(jQuery(".hidden_otourop").attr("value"));
      jQuery("input[name='owyz']").val(jQuery(".hidden_owyz").attr("value"));
   }

   var insuranceResolved = false;
   var needGetInsurance = true;
   var polskaCode = 59;

   function showInsurance(b) {
      if (insuranceResolved && b) {
         jQuery('#ubezpieczenie_box').show();
      } else {
         jQuery('#ubezpieczenie_box').hide();
      }
   }

   var insuranceGet = function () {
      if (needGetInsurance) {
         var depCountryCode = polskaCode;
         var destCountryCode = jQuery(".hidden_countryId").attr("value");
         var fromDate = stripDataMinus(jQuery(".hidden_data_od").attr("value"));
         var toDate = stripDataMinus(jQuery(".hidden_data_do").attr("value"));
         var dzieci = parseInt(jQuery(".hidden_lchd").attr("value"));
         var dorosli = parseInt(jQuery(".hidden_ladt").attr("value"));
         var persons = dorosli + dzieci;

      //if (jQuery("#hotel-param-offers label.active").length > 0) {
      //alert(jQuery(".hidden_oferta").attr("value"));
         if (jQuery(".hidden_oferta").attr("value") != '') {
            var insUrl = "https://www." + CONFIG.serwis + "/insurance-service.xml?";
            insUrl += 'dep=' + depCountryCode;
            insUrl += '&des=' + destCountryCode;
            insUrl += '&from=' + fromDate;
            insUrl += '&to=' + toDate;
            insUrl += '&persons=' + persons;
            jQuery.ajax({
               url: insUrl,
               dataType: 'xml',
               success: function (data) {
                  var xmlObj = jQuery(data);
                  var price = xmlObj.find("price").text();
                  var currency = xmlObj.find("currency").text();
                     if (price && currency) {
                        jQuery(".insurance .insurance-price").text(price);
                        jQuery(".insurance .insurance-currency").text(currency);
                        if (currency == 'PLN') currency = 'zł';
                        jQuery(".insurance .insurance-value").text(parseFloat(price, 10).toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, "$1\ ").replace("\.", ",") + ' ' + currency);
                        insuranceResolved = true;
                        showInsurance(true);
                        jQuery(".total-inurance2").hide();
                        jQuery("#total-insurance-price").hide();
                        refreshCheckBoxNew();
                        recalculateFinalPrice('');
                        needGetInsurance = false;
                     } else {
                        insuranceResolved = false;
                        showInsurance(false);
                     }
                  },
               error: function () {
                  insuranceResolved = false;
                  showInsurance(false);
               }
            });
         }
      }
   };

   function recalculateFinalPrice(pricetot) {
      var ubezPrice = parseFloat(jQuery(".insurance .insurance-price").text());
      //var price = jQuery("#hotel-param-offers label.active").find('.hidden-price-add').text();
      var price = '';
      if (pricetot != '') {
         price = pricetot;
      } else {
         price = jQuery(".total-price").text();
      }
      if (price != '') {
         console.log("PRICE will be recalculated. PRICE:" + price);
         jQuery(".order-form input[name='cenawyc']").val(formatPrice(price));
         if (jQuery("#ensurance:checked").length > 0) {
            var currency = findCurrency(price);
            var basePriceDig = digPrice(price, currency.length);
            price = basePriceDig + ubezPrice;
            price += ' zł';
            jQuery(".order-form input[name='ubez']").val('tak');
            jQuery(".order-form input[name='ubezp']").val(ubezPrice);
            var ubezc = jQuery(".insurance .insurance-currency").text();
            jQuery(".order-form input[name='ubezc']").val(ubezc);

            if (ubezc != '' && currency != '' && currency != 'zł') {
               jQuery(".total-inurance2").show();
               jQuery("#total-insurance-price").html(formatPrice(ubezPrice + " zł"));
               if (currency == '-1') {
                  jQuery("#total-price2").html('nieznana');
               } else {
                  jQuery("#total-price2").html(formatPrice(basePriceDig + " " + currency));
               }
            } else {
               jQuery(".total-inurance2").hide();
               var fPrice = formatPrice(price);
               jQuery("#total-price2").html(fPrice);
               jQuery(".order-form input[name='cenacalk']").val(fPrice);
	       jQuery(".hidden_cenacalk").attr("value", formatTotalPrice(fPrice));
            }
         } else {
            jQuery(".order-form input[name='ubez']").val('');
            jQuery(".order-form input[name='ubezp']").val('');
            jQuery(".order-form input[name='ubezc']").val('');
            jQuery(".total-inurance2").hide();

            var fPrice = formatPrice(price);
            jQuery(".order-form input[name='cenacalk']").val(fPrice);
	    jQuery(".hidden_cenacalk").attr("value", formatTotalPrice(fPrice));
            jQuery("#total-price2").html(fPrice);
         }
      } else {
         jQuery(".order-form input[name='cenawyc']").val('nieznana');
         jQuery("#total-price2").html('nieznana');
      }
   }

   function formatTotalPrice(price) {
      var currency = findTotalCurrency(price);
      if (currency == '-1') {
         return 'nieznana';
      } else {
         var basePriceDig = digPrice(price, currency.length);
         return parseFloat(basePriceDig, 10).toFixed(2).replace(" ", "").replace(",", "\.").toString() + ' ' + currency;
      }
   }

   function formatPrice(price) {
      var currency = findCurrency(price);
      if (currency == '-1') {
         return 'nieznana';
      } else {
         var basePriceDig = digPrice(price, currency.length);
         return parseFloat(basePriceDig, 10).toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, "$1\ ").replace("\.", ",").toString() + ' ' + currency;
      }
   }

   function refreshCheckBoxNew() {
      jQuery('.custom-checkbox').each(function() {
         if (jQuery(this).prev("span").length <= 0) {
            jQuery(this).before('<span class="custom-checkbox-new"></span>');
         }
         jQuery(this).click(function() {
            if (jQuery(this).attr('checked')) {
               jQuery(this).prev().addClass('checked');
            } else {
               jQuery(this).prev().removeClass('checked');
            }
         });
      });
      jQuery('.custom-checkbox:checked').prev().addClass('checked');
   }

   function digPrice(price, substr) {
      if (substr != -1) {
         var value = price.substr(0, price.length - substr).replace(" ", "");
         return parseFloat(value);
      }
      return price;
   }

   function findTotalCurrency(price) {
      if (price.indexOf("zł") != -1) return "PLN";
      if (price.indexOf("EUR") != -1) return "EUR";
      if (price.indexOf("USD") != -1) return "USD";
      if (price.indexOf("PLN") != -1) return "PLN";
      return "-1";
   }

   function findCurrency(price) {
      if (price.indexOf("zł") != -1) return "zł";
      if (price.indexOf("EUR") != -1) return "EUR";
      if (price.indexOf("USD") != -1) return "USD";
      if (price.indexOf("PLN") != -1) return "zł";
      return "-1";
   }

   function errorCenaNieznana() {
      loader.addClass("unavailable");
      loader.find('.check').addClass("unavailableicon");
      loader.find('.text').text("Oferta niedostępna");
      offerIsActive(false);

      jQuery(".order-form input[name='cenacalk']").val('nieznana');
      jQuery(".term-box .total-price").text('nieznana');
   }

   function stripDataMinus(data) {
      if (data != '' && data.length >= 8) {
         return data.substring(0,4) + data.substring(5,7) + data.substring(8);
      } else {
         return '';
      }
   }

   function validateSubmit() {
      jQuery(".order--form--submit").click(function(e) {
         //e.preventDefault();
         validateForm();
      });
   }

   function validateForm() {
      fillParams();
      var validator = new valids.Validator("zapytanie");
      validator.addValidation("tourOp","req","W adresie URL brakuje pola tourOp.");
      validator.addValidation("tourOp","maxlen=5","Touroperator w URL może mieć maksymalnie 5 znaków.");
      validator.addValidation("htlCode","req","W adresie URL brakuje pola htlCode.");
      validator.addValidation("htlCode","maxlen=20","Kod hotelu w URL może mieć maksymalnie 20 znaków.");
      validator.addValidation("kodId","req","W adresie URL brakuje pola kodId.");
      validator.addValidation("turnus","req","W adresie URL brakuje pola turnus.");
      validator.addValidation("turnus","maxlen=5","Nr turnusu w URL może mieć maksymalnie 5 znaków.");
      validator.addValidation("imie","req","Proszę podać swoje imię.");
      validator.addValidation("imie","maxlen=30","Imię może mieć maksymalnie 30 znaków.");
      validator.addValidation("nazwisko","req","Proszę podać swoje nazwisko.");
      validator.addValidation("nazwisko","maxlen=30","Nazwisko może mieć maksymalnie 30 znaków.");
      validator.addValidation("email1","req","Proszę podać adres e-mail.");
      validator.addValidation("email1","email","Proszę podać prawidłowy adres e-mail.");
      validator.addValidation("email1","maxlen=50","Adres e-mail może mieć maksymalnie 50 znaków.");
      validator.addValidation("tel_stac","req","Proszę podać telefon.");
      validator.addValidation("tel_stac","minlen=8","Numer telefonu powinien zawierać minimalnie 9 cyfr.");
      validator.addValidation("tel_stac","maxlen=20","Numer telefonu powinien zawierać maksymalnie 20 cyfr.");
      validator.addValidation("tel_stac","numeric","Numer telefonu powinien zawierać minimalnie 9 cyfr.");
      validator.addValidation("rodo","req","Proszę wyrazić zgodę na kontakt telefoniczny lub mailowy.");
      validator.addValidation("rodo","selmin=1","Proszę wyrazić zgodę na kontakt telefoniczny lub mailowy.");
      console.log("added validations");
   }
</script>

<style lang="scss" scoped>
   @import '@/scss/_components/_T1Rezerwacja';
</style>
